export default __webpack_public_path__ + "static/media/Scarlett Oherav.122892b9.png";